export default __webpack_public_path__ + "static/media/YUKI.4a30a783.png";